module.exports = __webpack_public_path__ + "img/PL00128.4555e9b0.png";